import { useNavigate } from 'react-router-dom';

// project imports
import { useAuth } from 'modules/auth/hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| ADMIN GUARD ||============================== //

/**
 * Admin role guard for routes
 */
const AdminGuard = ({ children }: GuardProps) => {
    const { isAdmin, isOwner } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isAdmin && !isOwner) {
            navigate('login', { replace: true });
        }
    }, [isAdmin, isOwner, navigate]);

    return children;
};

export default AdminGuard;
